export default __webpack_public_path__ + "ba97b1911e069ac99be74963e26c2339.png";